import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

// Soft elevated surface. Rounded, white background, subtle shadow. No more
// register-mark crosshairs — that was retro.
export const Card = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement> & { marks?: boolean }
>(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "relative rounded-lg bg-surface border border-rule shadow-soft",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
});
Card.displayName = "Card";

export function CardHeader({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "flex items-baseline justify-between gap-4 px-6 pt-5 pb-3 border-b border-rule",
        className,
      )}
      {...props}
    />
  );
}

export function CardBody({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("px-6 py-5", className)} {...props} />;
}

export function CardLabel({
  children,
  index,
}: {
  children: React.ReactNode;
  index?: string;
}) {
  return (
    <div className="flex items-baseline gap-3">
      {index && (
        <span className="font-mono text-label text-ink-faint">{index}</span>
      )}
      <span className="label">{children}</span>
    </div>
  );
}
